"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAG_APPEARANCES = void 0;
var _STATUS_TYPES = require("./STATUS_TYPES");
var TAG_APPEARANCES = Object.freeze(Object.assign({}, _STATUS_TYPES.STATUS_TYPES, {
  closeable: 'closeable',
  gray: 'gray',
  transparent: 'transparent',
  purple: 'purple',
  aqua: 'aqua',
  orange: 'orange'
}));
exports.TAG_APPEARANCES = TAG_APPEARANCES;